import { cn } from '@/lib/utils';

interface MetricCardProps {
  label: string;
  value: React.ReactNode;
  delta?: React.ReactNode;
  deltaDirection?: 'up' | 'down' | 'neutral';
  className?: string;
}

/**
 * KPI summary card.
 * Shows a 10px uppercase label, 22px value, and optional 11px delta row.
 * Uses bg-muted/50 surface — place 2–4 per row in a grid.
 */
export function MetricCard({ label, value, delta, deltaDirection = 'neutral', className }: MetricCardProps) {
  return (
    <div className={cn('rounded-md bg-muted/50 p-3', className)}>
      <p className="text-[10px] font-medium uppercase tracking-wider text-muted-foreground">
        {label}
      </p>
      <p className="mt-1 text-[22px] font-semibold leading-none text-foreground">
        {value}
      </p>
      {delta !== undefined && (
        <p
          className={cn(
            'mt-1 text-[11px]',
            deltaDirection === 'up'   && 'text-cx-success',
            deltaDirection === 'down' && 'text-cx-danger',
            deltaDirection === 'neutral' && 'text-muted-foreground',
          )}
        >
          {delta}
        </p>
      )}
    </div>
  );
}
